/** Redondeo a la décima más cercana (0.1). */
export function roundToNearestTenth(n: number): number {
  return Math.round(n * 10) / 10;
}

/** Redondeo del precio público a la cincuentena de pesos más cercana (p. ej. 8821 → 8800, 8825 → 8850). */
export function roundPublicPriceToNearestFifty(n: number): number {
  return Math.round(n / 50) * 50;
}

/**
 * Precio público sugerido: (costo / ((100 − comisión%) / 100)) + 250 (MXN),
 * redondeado a la cincuentena más cercana.
 */
export function computeAutoPublicPrice(cost: number, commissionPercent: number): number {
  if (!Number.isFinite(cost) || !Number.isFinite(commissionPercent)) {
    return roundPublicPriceToNearestFifty(250);
  }
  const divisor = (100 - commissionPercent) / 100;
  if (!(divisor > 0)) {
    return roundPublicPriceToNearestFifty(250);
  }
  return roundPublicPriceToNearestFifty(cost / divisor + 250);
}
